module.exports = __webpack_public_path__ + "img/Captura de Pantalla 2022-04-20 a la(s) 08.45 1.fb8d6d9f.png";